module.exports = __webpack_public_path__ + "img/visa.f1d1c2a0.svg";